/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RoleDto } from './RoleDto';
import {
    RoleDtoFromJSON,
    RoleDtoFromJSONTyped,
    RoleDtoToJSON,
    RoleDtoToJSONTyped,
} from './RoleDto';
import type { TimezoneMetadata } from './TimezoneMetadata';
import {
    TimezoneMetadataFromJSON,
    TimezoneMetadataFromJSONTyped,
    TimezoneMetadataToJSON,
    TimezoneMetadataToJSONTyped,
} from './TimezoneMetadata';

/**
 * 
 * @export
 * @interface RoleListResponse
 */
export interface RoleListResponse {
    /**
     * 
     * @type {Array<RoleDto>}
     * @memberof RoleListResponse
     */
    data?: Array<RoleDto>;
    /**
     * 
     * @type {number}
     * @memberof RoleListResponse
     */
    total?: number;
    /**
     * 
     * @type {number}
     * @memberof RoleListResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof RoleListResponse
     */
    pageSize?: number;
    /**
     * 
     * @type {string}
     * @memberof RoleListResponse
     */
    userTimezone?: string;
    /**
     * Indicates if the request was successful
     * @type {boolean}
     * @memberof RoleListResponse
     */
    success?: boolean;
    /**
     * Error message if the request failed
     * @type {string}
     * @memberof RoleListResponse
     */
    error?: string;
    /**
     * 
     * @type {TimezoneMetadata}
     * @memberof RoleListResponse
     */
    timezoneMetadata?: TimezoneMetadata;
}

/**
 * Check if a given object implements the RoleListResponse interface.
 */
export function instanceOfRoleListResponse(value: object): value is RoleListResponse {
    return true;
}

export function RoleListResponseFromJSON(json: any): RoleListResponse {
    return RoleListResponseFromJSONTyped(json, false);
}

export function RoleListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RoleListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(RoleDtoFromJSON)),
        'total': json['total'] == null ? undefined : json['total'],
        'page': json['page'] == null ? undefined : json['page'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
        'userTimezone': json['userTimezone'] == null ? undefined : json['userTimezone'],
        'success': json['success'] == null ? undefined : json['success'],
        'error': json['error'] == null ? undefined : json['error'],
        'timezoneMetadata': json['timezone_metadata'] == null ? undefined : TimezoneMetadataFromJSON(json['timezone_metadata']),
    };
}

export function RoleListResponseToJSON(json: any): RoleListResponse {
    return RoleListResponseToJSONTyped(json, false);
}

export function RoleListResponseToJSONTyped(value?: RoleListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(RoleDtoToJSON)),
        'total': value['total'],
        'page': value['page'],
        'pageSize': value['pageSize'],
        'userTimezone': value['userTimezone'],
        'success': value['success'],
        'error': value['error'],
        'timezone_metadata': TimezoneMetadataToJSON(value['timezoneMetadata']),
    };
}

